import { unsafeCSS } from 'lit';
import { css, CSSResultGroup } from 'lit-element';
import { getSpacingValues } from '../../macros' with { type: 'macro' };

const propertyMap = {
  mt: 'margin-top',
  mb: 'margin-bottom',
  ml: 'margin-left',
  mr: 'margin-right',
  pt: 'padding-top',
  pb: 'padding-bottom',
  pl: 'padding-left',
  pr: 'padding-right',
  p: 'padding',
};

const generateSpacingClasses = (property: keyof typeof propertyMap, values: number[]): CSSResultGroup => {
  // eslint-disable-next-line security/detect-object-injection
  const cssProperty = propertyMap[property];
  const styles = values
    .map(
      (value) => `
      .${property}-${value} {
        ${cssProperty}: ${value}px;
      }
    `
    )
    .join('');
  return css`
    ${unsafeCSS(styles)}
  `;
};

const spacingValues = getSpacingValues();
// This is for Margin 0 and Padding 0
spacingValues.push(0);

export const ludsSpacing = css`
  ${generateSpacingClasses('mt', spacingValues)}
  ${generateSpacingClasses('mb', spacingValues)}
  ${generateSpacingClasses('ml', spacingValues)}
  ${generateSpacingClasses('mr', spacingValues)}
  ${generateSpacingClasses('pt', spacingValues)}
  ${generateSpacingClasses('pb', spacingValues)}
  ${generateSpacingClasses('pl', spacingValues)}
  ${generateSpacingClasses('pr', spacingValues)}
  ${generateSpacingClasses('p', spacingValues)}
`;
